module.exports = __webpack_public_path__ + "static/media/1008282.9ef592f4.png";